// @ts-strict-ignore
import { components } from 'react-select';

import { Icon } from 'components/Icon';

export function ClearIndicator(props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.ClearIndicator {...props}>
      <Icon initialColorName="todo-replace-me" name="close" size={12} />
    </components.ClearIndicator>
  );
}
